import { render, staticRenderFns } from "./timesheet_site_workers.vue?vue&type=template&id=b45035b2&scoped=true"
import script from "./timesheet_site_workers.vue?vue&type=script&lang=js"
export * from "./timesheet_site_workers.vue?vue&type=script&lang=js"
import style0 from "./timesheet_site_workers.vue?vue&type=style&index=0&id=b45035b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45035b2",
  null
  
)

export default component.exports